export function generateTimeEstimateMessage(timeRemaining: number) {
  const timeRemainingText =
    timeRemaining > 0 && isFinite(timeRemaining)
      ? timeRemaining < 60
        ? `${Math.round(timeRemaining)} secs`
        : `${Math.round(timeRemaining / 60)} mins`
      : "";
  return timeRemainingText ? `Est time remaining: ${timeRemainingText}` : "";
}

export function generateTimeRemainingMessage(timeRemaining: number) {
  const timeRemainingText =
    timeRemaining > 0
      ? timeRemaining < 60
        ? `${Math.round(timeRemaining)} seconds`
        : `${Math.round(timeRemaining / 60)} minutes`
      : "";
  return timeRemainingText ? `${timeRemainingText} remaining` : "";
}
